export default {
      id: "onesite-o-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "sprite.svg#onesite-o",
      toString: function () {
        return this.url;
      }
    }